import { ACTION_CODES } from "@features/entity/types/actionCodes";

/** Remove-user action code for each entity scope (non-DEPT; used by role-assignment Remove). */
export const REMOVE_USER_ACTION_BY_SCOPE: Record<"NATION" | "DISTRICT" | "CHURCH", string> = {
    NATION: ACTION_CODES.REMOVE_USER_NAT,
    DISTRICT: ACTION_CODES.REMOVE_USER_DIST,
    CHURCH: ACTION_CODES.REMOVE_USER_CHURCH,
};

export function getRemoveUserActionForScope(scope: string): string {
    const normalized = scope.toUpperCase() as keyof typeof REMOVE_USER_ACTION_BY_SCOPE;
    return REMOVE_USER_ACTION_BY_SCOPE[normalized] ?? ACTION_CODES.REMOVE_USER_CHURCH;
}
